import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  formatCurrency,
  formatProjectedSellout,
  getSellThroughStatusMeta,
} from './pricingLevelPerformanceUtils'

function ForecastMetric({ label, value }) {
  return (
    <div className="pricing-level-forecast-metric">
      <span className="pricing-level-forecast-metric__label">{label}</span>
      <span className="pricing-level-forecast-metric__value">{value}</span>
    </div>
  )
}

export default function PricingLevelForecastedRevenue({ forecastedRevenue }) {
  const cards = forecastedRevenue || []

  if (!cards.length) return null

  return (
    <div className="pricing-level-forecasted-revenue">
      <div className="pricing-level-forecasted-revenue__header">
        <h2 className="h5 mb-1">Forecasted Revenue</h2>
        <p className="small text-muted mb-0">
          Projected final revenue and sellout timing by pricing level.
        </p>
      </div>

      <Row className="g-3 mt-1">
        {cards.map((card) => {
          const meta = getSellThroughStatusMeta(card.sellThroughStatus)

          return (
            <Col key={card.pricingLevelId} sm={6} xl={4} xxl={3}>
              <Card
                body
                className={`card--xs card-with-border h-100 pricing-level-forecast-card pricing-level-forecast-card--${card.sellThroughStatus}`}
              >
                <div className="pricing-level-forecast-card__head">
                  <h3 className="pricing-level-forecast-card__title">
                    {card.name}
                  </h3>
                  <span
                    className="pricing-level-forecast-card__status"
                    aria-hidden
                  >
                    {meta.emoji}
                  </span>
                </div>

                <ForecastMetric
                  label="Current Revenue"
                  value={formatCurrency(card.currentRevenue)}
                />
                <ForecastMetric
                  label="Forecast Revenue"
                  value={formatCurrency(card.forecastRevenue)}
                />
                <ForecastMetric
                  label="Projected Sellout"
                  value={formatProjectedSellout({
                    remaining: card.remaining,
                    days: card.projectedSelloutDays,
                  })}
                />
              </Card>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
